












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { UserModule } from '@/store/modules/user';
import * as fb from '@/firebase';
import { UserProfile } from '@/models/user-profile';
import UserAvatar from '@/components/UserAvatar.vue';


import AddItemModal from '@/modals/AddItemModal.vue';

@Component({
  // @ts-ignore
  components: {
    AddItemModal,
    UserAvatar
  }
})
export default class App extends Vue {
  @Watch('UserModule.isLoggedIn')
  get isLoggedIn(): boolean {
    return UserModule.isLoggedIn;
  }

  @Watch('UserModule.userProfile')
  get userProfile(): UserProfile {
    return UserModule.userProfile;
  }

  @Watch("$route.meta.title")
  updateTitle() {
    if (this.$route.meta.title) {
      document.title = 'mixlet: ' + this.$route.meta.title
    }
  }

  get loggedInStatus(): string {
    const currentUser = UserModule.currentUser;
    
    if (currentUser) {
      return 'Logged in as: ' + currentUser.displayName || '???';
    } else {
      return 'Not logged in';
    }
  }

  showAddModal() {
    this.$modal.show(AddItemModal, {}, { adaptive: true, classes: 'null-modal-class' });
  }

  get headerClasses() {
    return {
      'hide-header-on-mobile': this.$route.meta.hideHeaderOnMobile
    }
  }

  get metaInfo() {
     return {
      title: 'Mixlet'
    }
  }
}
